import script from "./icon-user-add.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-user-add.vue?vue&type=script&lang=ts&setup=true"

import "./icon-user-add.vue?vue&type=style&index=0&id=4287201e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4287201e"]])

export default __exports__